<!-- Loading overlay - prevents FOUC during page reload while layout initializes -->
@if (!isLayoutReady()) {
  <div 
    class="fixed inset-0 bg-zinc-50 dark:bg-zinc-900 z-[9999] flex items-center justify-center"
    role="status"
    aria-label="Loading application"
    aria-live="polite">
    <div class="flex flex-col items-center gap-4">
      <div class="w-10 h-10 border-4 border-primary-500 border-t-transparent rounded-full animate-spin" aria-hidden="true"></div>
      <span class="sr-only">Loading...</span>
    </div>
  </div>
}

<!-- Learner/Admin/Trainer modules use their own headers via their respective LayoutComponents -->
<!-- Global header only shown for routes that don't have their own layout (e.g., public pages) -->
@if (!isLearnerRoute() && !isAdminRoute() && !isTrainerRoute() && !isLoginRoute() && !appStateService.isInCallbackFlow()) {
  <app-header></app-header>
}

<p-toast></p-toast> 

<router-outlet></router-outlet>

@if (!appStateService.isInCallbackFlow() && !isLearnerRoute() && !isAdminRoute() && !isTrainerRoute() && !isLoginRoute()) {
  <app-footer></app-footer>
}
